"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const isNonNullish = (input) => {
  return input != null;
};
const isNonEmptyArray = (input) => {
  return !!input.length;
};
const richText = (field) => {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};
const title = richText;
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const image = imageThumbnail;
const link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};
const linkToMedia = link;
const contentRelationship = link;
const date = isNonNullish;
const timestamp = isNonNullish;
const color = isNonNullish;
const number = isNonNullish;
const keyText = (field) => {
  return isNonNullish(keyText) && !!field;
};
const select = isNonNullish;
const embed = (field) => {
  return isNonNullish(field) && !!field.embed_url;
};
const geoPoint = (field) => {
  return isNonNullish(field) && "longitude" in field;
};
const table = isNonNullish;
const integration = isNonNullish;
const integrationField = integration;
const integrationFields = integration;
const repeatable = (repeatable2) => {
  return isNonNullish(repeatable2) && isNonEmptyArray(repeatable2);
};
const group = (group2) => {
  return isNonNullish(group2) && isNonEmptyArray(group2);
};
const sliceZone = (slices) => {
  return isNonNullish(slices) && isNonEmptyArray(slices);
};
exports.color = color;
exports.contentRelationship = contentRelationship;
exports.date = date;
exports.embed = embed;
exports.geoPoint = geoPoint;
exports.group = group;
exports.image = image;
exports.imageThumbnail = imageThumbnail;
exports.integration = integration;
exports.integrationField = integrationField;
exports.integrationFields = integrationFields;
exports.keyText = keyText;
exports.link = link;
exports.linkToMedia = linkToMedia;
exports.number = number;
exports.repeatable = repeatable;
exports.richText = richText;
exports.select = select;
exports.sliceZone = sliceZone;
exports.table = table;
exports.timestamp = timestamp;
exports.title = title;
//# sourceMappingURL=isFilled.cjs.map
